import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Chanz Automation helpdesk widget. Loaded at runtime (rather than in index.html) so we can
// keep it off public/legal routes that should stay chrome-free.
const WIDGET_SRC =
  'https://bizsolutions.chanzautomation.com/api/helpdesk/widget.js?key=wk_c16a021f5c2bb6dac6491c8e3dc84b77415df7ef8749eac6';
const WIDGET_SCRIPT_ID = 'helpdesk-widget-script';

// Route prefixes where the support widget must NOT appear.
const HIDDEN_PREFIXES = ['/terms', '/privacy'];

// Remove the injected script and any DOM the vendor widget added (scoped to its origin/name).
function removeWidgetArtifacts() {
  document.getElementById(WIDGET_SCRIPT_ID)?.remove();
  document
    .querySelectorAll('iframe[src*="chanzautomation"], [id*="helpdesk" i], [class*="helpdesk" i]')
    .forEach((el) => el.remove());
}

/**
 * Mounts once at the app root and injects the helpdesk widget only on allowed routes.
 * On hidden routes it removes the script and any widget DOM, so deep-linking or client-side
 * navigation to /terms or /privacy never shows the widget.
 */
export default function HelpdeskWidget() {
  const { pathname } = useLocation();
  const hidden = HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  useEffect(() => {
    if (hidden) {
      removeWidgetArtifacts();
      return;
    }
    if (!document.getElementById(WIDGET_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = WIDGET_SCRIPT_ID;
      script.src = WIDGET_SRC;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, [hidden, pathname]);

  return null;
}
